import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Table, Form, Button } from "react-bootstrap";
import toast from "react-hot-toast";
import { makeParams } from "../../../../../api/makeRequest";
import StudentService from "../../../../../services/student.service";
import Select from "react-select";
import ReactDatePicker from "react-datepicker";
import { CSVLink } from "react-csv";
import { NormalText } from "../../../../../components/Text/TableText.formats";
import { IsLoading } from "../../../../../App.context";
import { countries } from "../../../../../utilis/country.utiils";
import TablePagination from "../../../../../components/Pagination";
import ViewEnrollmentModal from "../../../../../components/Modals/ViewEnrollment.modal";
import { useNavigate } from "react-router";

export const PaidEnrollmentsTable = () => {
    const [allEnrollments, setAllEnrollments] = useState<any[]>([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState("");
    const [total, setTotal] = useState(0);
    const [csvData, setCSVData] = useState<any[]>([]);
    const [country, setCountry] = useState<any>("");
    const { setLoading }: any = useContext(IsLoading);
    const [selectedEnrollment, setSelectedEnrollment] = useState<any>(null);

    const [dateRange, setDateRange] = useState({
        startDate: moment().startOf('month').toDate(),
        endDate: moment().toDate(),
    });

    async function getAllStudents() {
        let params = [
            { index: 'pageNumber', value: pageNumber },
            { index: 'pageSize', value: pageSize },
            { index: "searchText", value: search }
        ];

        if (dateRange.startDate && dateRange.endDate) {
            params.push({ index: "startDate", value: moment(dateRange.startDate).format("DD/MM/YYYY") });
            params.push({ index: "endDate", value: moment(dateRange.endDate).format("DD/MM/YYYY") });
        }

        let qParams = makeParams(params);
        let payload = {};

        if (country && country?.value) {
            payload = { country: country?.value }
        }

        setLoading(true);
        await StudentService.getPaidEnrollments(qParams, payload)
            .then((res) => {
                if (res.status === 200) {
                    setAllEnrollments(res.data?.enrollments || []);
                    // createCSVData(res.data?.enrollments);
                    setTotal(res.data?.count || 0);
                }
            })
            .catch((err: any) => {
                toast.error("Unable to fetch Students");
            })
            .finally(() => {
                setLoading(false);
            })
    }

    async function getAllStudentsForCSV() {
        let params = [
            { index: 'pageNumber', value: 1 },
            { index: 'pageSize', value: 9999999999 },
            { index: "searchText", value: search }
        ];

        if (dateRange.startDate && dateRange.endDate) {
            params.push({ index: "startDate", value: moment(dateRange.startDate).format("DD/MM/YYYY") });
            params.push({ index: "endDate", value: moment(dateRange.endDate).format("DD/MM/YYYY") });
        }

        let qParams = makeParams(params);
        let payload = {};

        if (country && country?.value) {
            payload = { country: country?.value }
        }

        setLoading(true);
        await StudentService.getPaidEnrollments(qParams, payload)
            .then((res) => {
                if (res.status === 200) {
                    createCSVData(res.data?.enrollments);
                }
            })
            .catch((err: any) => {
                toast.error("Unable to fetch Students");
            })
            .finally(() => {
                setLoading(false);
            })
    }


    function createCSVData(allData: any[]) {
        if (!allData?.length) {
            toast.error("No data found");
            return false;
        }

        let data = allData?.map((item: any) => {
            return {
                "Enrollment Id": item?.enrollmentId ? item.enrollmentId : "N.A.",
                "Student": (item?.student?.firstName && item?.student.firstName) + " " + (item?.student?.lastName && item?.student.lastName),
                "Instructor": (item?.student?.firstName && item?.instructor.firstName) + " " + (item?.instructor?.lastName && item?.instructor.lastName),
                "Instrument": item?.course?.instrument || "N/A",
                "Enrollment Date": item?.createdAt || "N/A",
                "Country": item?.student?.country || "N/A",
                "Total Classes": item?.payment_details?.[0]?.num_classes || "N/A",
                "Total Cost": item?.payment_details?.[0]?.total_price?.toFixed(2) || "N/A",
            }
        });

        setCSVData(data);
    }

    useEffect(() => {
        if ((!dateRange.startDate && dateRange.endDate) || (dateRange.startDate && !dateRange.endDate)) {
            return
        }
        getAllStudents();
    }, [pageNumber, pageSize, dateRange, country]);


    useEffect(() => {
        setTimeout(() => {
            getAllStudents();
        }, 500);
    }, [search]);

    const navigate = useNavigate();

    return (
        <>
            <div className="d-flex justify-content-between">
                <div className="d-flex gap-2">
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold text-secondary fs-12">
                            Search
                        </Form.Label>
                        <Form.Control type="text" placeholder="Search" onChange={(e) => setSearch(e.target.value)} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold text-secondary fs-12">
                            Date Range
                        </Form.Label>
                        <ReactDatePicker
                            onChange={(e: any) => {
                                setDateRange({
                                    startDate: e[0],
                                    endDate: e[1],
                                });
                            }}
                            startDate={dateRange.startDate}
                            endDate={dateRange.endDate}
                            selectsRange
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            isClearable
                            placeholderText="Select Date Range"
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold text-secondary fs-12">
                            Country
                        </Form.Label>
                        <Select
                            options={countries.map((country) => {
                                return {
                                    label: country,
                                    value: country,
                                };
                            })}
                            value={country}
                            onChange={(e) => {
                                setCountry(e);
                            }}
                            isClearable
                        />
                    </Form.Group>
                </div>
                <div className="d-flex gap-2">
                    <div>
                        <Button size="sm" variant="primary" onClick={() => getAllStudentsForCSV()}>Create CSV</Button>
                    </div>
                    {
                        csvData && csvData?.length > 0 &&
                        <CSVLink data={csvData} filename={"paid-enrollments.csv"}>
                            <Button size="sm" variant="primary">Download</Button>
                        </CSVLink>
                    }
                </div>
            </div>
            <Table bordered hover responsive size="sm">
                <thead>
                    <tr className="text-secondary" style={{ fontSize: "12px" }}>
                        <th>#</th>
                        <th>Enrollment Id</th>
                        <th>Student</th>
                        <th>Instructor</th>
                        <th>Instrument</th>
                        <th>Enrollment Date</th>
                        <th>Country</th>
                        <th>Total Classes</th>
                        <th>Total Cost</th>
                        <th>PPC</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        allEnrollments?.length > 0 ? allEnrollments?.map((item: any, index: number) => {
                            return (
                                <tr>
                                    <td>{pageSize * (pageNumber - 1) + index + 1}</td>
                                    <td className="fw-bold" style={{ cursor: "pointer" }} onClick={() => setSelectedEnrollment(item?._id)}>{item?.enrollmentId}</td>
                                    <td>
                                        <u className="text-primary fs-12 fw-bold fs-underline cursor-pointer" 
                                        onClick={() => navigate(`/admin/search/student/detail/${item?.student?._id}`)}>
                                            {item?.student?.firstName && item?.student?.firstName}{" "}
                                            {item?.student?.lastName && item?.student?.lastName}
                                        </u>
                                        <div>
                                            <NormalText value={item?.student?.email || "N.A."} />
                                        </div>
                                        <div className="text-info fw-bold">
                                            {item?.student?.phone ? item?.student?.phone : "--"}
                                        </div>
                                        <div className="text-info fw-bold">
                                            {item?.student?.country ? item?.student?.country : "--"}
                                        </div>
                                    </td>
                                    <td>
                                        <u
                                            className="text-primary fs-12 fw-bold fs-underline cursor-pointer"
                                            onClick={() => navigate(`/admin/search/instructor/detail/${item?.student?._id}`)}
                                        >
                                            {item?.instructor?.firstName && item?.instructor?.firstName}{" "}
                                            {item?.instructor?.lastName && item?.instructor?.lastName}
                                        </u>
                                        <div>
                                            <NormalText value={item?.instructor?.email || "N.A."} />
                                        </div>
                                        <div className="text-info fw-bold">
                                            {item?.instructor?.phone ? item?.instructor?.phone : "--"}
                                        </div>
                                    </td>
                                    <td>
                                        <NormalText value={item?.course?.instrument || "N.A."} />
                                    </td>
                                    <td>{item?.createdAt ? moment(item?.createdAt).format("DD/MM/YYYY") : "N/A"}</td>
                                    <td>
                                        <NormalText value={item?.student?.country || "N.A."} />
                                    </td>
                                    <td>
                                        <NormalText value={item?.payment_details?.[0]?.num_classes || "N.A."} />
                                    </td>
                                    <td>
                                        <NormalText value={item?.payment_details?.[0]?.total_price?.toFixed(2) || "N.A."} />
                                    </td>
                                    <td>
                                        <NormalText value={item?.price_per_class?.toFixed(2) || "N.A."} />
                                    </td>
                                </tr>
                            )
                        })
                            :
                            <tr>
                                <td colSpan={13}>
                                    No data found.
                                </td>
                            </tr>
                    }
                </tbody>
            </Table>

            <TablePagination
                total={total}
                currentPage={pageNumber}
                perPage={pageSize}
                handlePageChange={setPageNumber}
                setPerPage={setPageSize}
            />

            <ViewEnrollmentModal
                show={selectedEnrollment}
                handleClose={setSelectedEnrollment}
            />
        </>

    );
};

export default PaidEnrollmentsTable;